/**
 * Format cents as a dollar string with commas.
 * e.g. 123456 → "$1,234.56"
 */
export function formatCents(cents: number | null | undefined): string {
  if (cents == null) return '$0.00';
  const dollars = cents / 100;
  return dollars.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  });
}

/**
 * Format cents as a compact dollar string (no decimals for whole dollars).
 * e.g. 780000 → "$7,800"
 */
export function formatCentsCompact(cents: number | null | undefined): string {
  if (cents == null) return '$0';
  const dollars = cents / 100;
  if (dollars % 1 === 0) {
    return dollars.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
    });
  }
  return formatCents(cents);
}
